module.exports = __webpack_public_path__ + "static/media/Folder 291.562bfe81.png";